import React from 'react';

import makeDeprecatedJadeStyleTemplate from 'util/makeDeprecatedJadeStyleTemplate';

function EmptySequencePrimer(): JSX.Element {
  return (
    <form className="buffer-content-container form-horizontal js-empty-sequence">
      <fieldset>
        <legend>Design</legend>
        <p>
          Primer design is disabled on empty sequences. Add bases to your sequence before designing a primer.
        </p>
      </fieldset>
    </form>
  );
}

export default makeDeprecatedJadeStyleTemplate(EmptySequencePrimer);
